<template>
  <modal
    class="addNewRetainershipModal"
    name="waybillDetailsModal"
    transition="pop-out"
    :width="modalWidth"
    :height="500"
    @opened="opened"
    @closed="closed"
  >
    <div class="retainership__box">
      <button
        type="button"
        class="close modal-close"
        aria-label="Close"
        @click="closeModal"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="text-center">
        <h3 class="mt-2 add__retainership__header">
          <span>
            <img src="@/assets/img/Group 440.png" width="50px" />
          </span>
          {{ $t("text.waybillModal.wbDetFor") }}
          {{ waybillDetails.referenceNumber }}
        </h3>
        <!-- <p>{{ waybillId }}</p> -->
        <div class="sign_up_form_section">
          <form>
            <div>
              <p>{{ messages }}</p>
            </div>

            <div class="row">
              <div class="col-md-3 mt-4">
                {{ $t("text.waybillModal.companyName") }}
              </div>
              <div class="col-md-9">
                <div class="mt-3 form_input_section">
                  <input
                    disabled
                    type="text"
                    v-model="waybillDetails.companyName"
                    class="form-control w-100"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 mt-4">
                {{ $t("text.waybillModal.companyAddress") }}
              </div>
              <div class="col-md-9">
                <div class="mt-3 form_input_section">
                  <input
                    disabled
                    type="text"
                    v-model="waybillDetails.companyAddress"
                    class="form-control w-100"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 mt-4">
                {{ $t("text.waybillModal.productName") }}
              </div>
              <div class="col-md-9">
                <div class="mt-3 form_input_section">
                  <input
                    disabled
                    type="text"
                    v-model="waybillDetails.productName"
                    class="form-control w-100"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 mt-4">
                {{ $t("text.waybillModal.companyName") }}
              </div>
              <div class="col-md-9">
                <div class="mt-3 form_input_section">
                  <input
                    disabled
                    type="text"
                    v-model="waybillDetails.companyName"
                    class="form-control w-100"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 mt-4">
                {{ $t("text.waybillModal.orderNo") }}
              </div>
              <div class="col-md-9">
                <div class="mt-3 form_input_section">
                  <input
                    disabled
                    type="text"
                    v-model="waybillDetails.orderNumber"
                    class="form-control w-100"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 mt-4">
                {{ $t("text.waybillModal.refNumber") }}
              </div>
              <div class="col-md-9">
                <div class="mt-3 form_input_section">
                  <input
                    disabled
                    type="text"
                    v-model="waybillDetails.referenceNumber"
                    class="form-control w-100"
                  />
                </div>
              </div>
            </div>

            <div class="row" v-if="waybillDetails.truckId == null">
              <div class="col-md-3 mt-4">
                {{ $t("text.waybillModal.unregisteredTruck") }}
              </div>
              <div class="col-md-9">
                <div class="mt-3 form_input_section">
                  <input
                    disabled
                    type="text"
                    v-model="waybillDetails.unregisteredTruck"
                    class="form-control w-100"
                  />
                </div>
              </div>
            </div>
            <!-- <div v-else>
              
            </div> -->
            <div v-if="waybillDetails.driverId !== null">
              <div class="row">
                <div class="col-md-3 mt-4">
                  {{ $t("text.waybillModal.driverName") }}
                </div>
                <div class="col-md-9">
                  <div class="mt-3 form_input_section">
                    <input
                      disabled
                      type="text"
                      v-model="waybillDetails.driverName"
                      class="form-control w-100"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3 mt-4">
                  {{ $t("text.waybillModal.driverEmail") }}
                </div>
                <div class="col-md-9">
                  <div class="mt-3 form_input_section">
                    <input
                      disabled
                      type="text"
                      v-model="waybillDetails.driverEmail"
                      class="form-control w-100"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3 mt-4">
                  {{ $t("text.waybillModal.driverPhone") }}
                </div>
                <div class="col-md-9">
                  <div class="mt-3 form_input_section">
                    <input
                      disabled
                      type="text"
                      v-model="waybillDetails.driverPhoneNumber"
                      class="form-control w-100"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3 mt-4">
                  {{ $t("text.waybillModal.truckName") }}
                </div>
                <div class="col-md-9">
                  <div class="mt-3 form_input_section">
                    <input
                      disabled
                      type="text"
                      v-model="waybillDetails.truckName"
                      class="form-control w-100"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3 mt-4">
                  {{ $t("text.waybillModal.licensePlate") }}
                </div>
                <div class="col-md-9">
                  <div class="mt-3 form_input_section">
                    <input
                      disabled
                      type="text"
                      v-model="waybillDetails.plateNumber"
                      class="form-control w-100"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 mt-4">
                {{ $t("text.waybillModal.waybillDate") }}
              </div>
              <div class="col-md-9">
                <div class="mt-3 form_input_section">
                  <input
                    disabled
                    type="text"
                    v-model="waybillDetails.wayBillDate"
                    class="form-control w-100"
                  />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-3 mt-4">Comment</div>
              <div class="col-md-9">
                <div class="mt-3 form_input_section">
                  <input
                    disabled
                    type="text"
                    v-model="waybillDetails.comment"
                    class="form-control w-100"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import configObject from "@/config";
import JQuery from "jquery";
let $ = JQuery;

const MODAL_WIDTH = 700;

export default {
  name: "waybillDetailsModal",
  props: ["waybillId"],
  data() {
    return {
      modalWidth: MODAL_WIDTH,
      // formIsValid: false,
      waybillDetails: [],
      messages: "",
    };
  },
  created() {
    this.showLoader = true;
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
    // console.log("waybill details created");
  },
  // mounted() {
  //   // this.getWaybillDetails();
  //   console.log("waybill details mounted");
  // },
  methods: {
    opened() {
      // console.log("waybill details opened");
      this.getWaybillDetails();
    },
    closed() {
      this.waybillDetails = "";
      // console.log("waybill details closed");
    },
    closeModal() {
      this.$modal.hide("waybillDetailsModal");
      // this.waybillId = "";
      this.waybillDetails = "";
    },
    getWaybillDetails() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Waybill/Get/${this.waybillId}`,
          configObject.authConfig()
        )
        .then((response) => {
          // console.log(response);
          this.waybillDetails = response.data;
        })
        .catch((error) => {
          this.messages = error;
          // console.log(error);
        });
    },
  },
};
</script>
